import { render } from "./CardBase.vue?vue&type=template&id=88f49fe8"
import script from "./CardBase.vue?vue&type=script&lang=js"
export * from "./CardBase.vue?vue&type=script&lang=js"

import "./CardBase.vue?vue&type=style&index=0&id=88f49fe8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__